function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 200,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 175,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 150,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 125,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 100,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 75,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 50,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 205.109,
  r: 25,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

function SvgSideCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 266,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk1IiBoZWlnaHQ9IjI2NiIgdmlld0JveD0iMCAwIDE5NSAyNjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8Y2lyY2xlIGN4PSIyMDUiIGN5PSIyMDUuMTA5IiByPSIyMDAiIHN0cm9rZT0iI0UwRjFGRiIgc3Ryb2tlLXdpZHRoPSIxMCIvPg0KPGNpcmNsZSBjeD0iMjA1IiBjeT0iMjA1LjEwOSIgcj0iMTc1IiBzdHJva2U9IiNFMEYxRkYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjxjaXJjbGUgY3g9IjIwNSIgY3k9IjIwNS4xMDkiIHI9IjE1MCIgc3Ryb2tlPSIjRTBGMUZGIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIyMDUiIGN5PSIyMDUuMTA5IiByPSIxMjUiIHN0cm9rZT0iI0UwRjFGRiIgc3Ryb2tlLXdpZHRoPSIxMCIvPg0KPGNpcmNsZSBjeD0iMjA1IiBjeT0iMjA1LjEwOSIgcj0iMTAwIiBzdHJva2U9IiNFMEYxRkYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjxjaXJjbGUgY3g9IjIwNSIgY3k9IjIwNS4xMDkiIHI9Ijc1IiBzdHJva2U9IiNFMEYxRkYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjxjaXJjbGUgY3g9IjIwNSIgY3k9IjIwNS4xMDkiIHI9IjUwIiBzdHJva2U9IiNFMEYxRkYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjxjaXJjbGUgY3g9IjIwNSIgY3k9IjIwNS4xMDkiIHI9IjI1IiBzdHJva2U9IiNFMEYxRkYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjwvc3ZnPg0K";
export { SvgSideCard as ReactComponent };